/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

 function viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

(function($) {

	//=============================================
    // mamboFixThis plugin
    //=============================================

    $.fn.mamboFixThis = function( options ) {

    	
		// Default options
        var settings = $.extend({
            el: $(this),
            thresholdElement: null,
            requiredVPW: 0,
            topBuffer: 0,
            horizontalOffsetFrom: 'left',
            fixedHorizontalOffset: 0,
            initialHorizontalOffset: 0
        }, options );


        if( settings.thresholdElement === null ) {
        	return;
        }


        return this.each(function() {

	        var el = settings.el,
	        	topBuffer = settings.topBuffer,
	        	thresholdElement = settings.thresholdElement,
	        	requiredVPW = settings.requiredVPW,
	        	horizontalOffsetFrom = settings.horizontalOffsetFrom,
	        	fixedHorizontalOffset = settings.fixedHorizontalOffset,
	        	initialHorizontalOffset = settings.initialHorizontalOffset,
	        	vpw = viewport().width;


	        // If minimum viewport width is met
	        if( vpw >= requiredVPW ) {

	        	var thresholdTop = thresholdElement.offset().top - topBuffer,
	        		thresholdBottom = thresholdElement.offset().top + thresholdElement.height() - el.height() - topBuffer,
	            	windowTop = $(window).scrollTop(),
	            	css = {};



	            // If scrolling past thresholdBottom, snap element to bottom of container and width to 100%
		        if( windowTop > thresholdBottom ) {

		        	css.position 				= 'absolute';
		        	css.top 					= 'auto';
		        	css.bottom 					= '0';
		        	css[horizontalOffsetFrom] 	= initialHorizontalOffset;

		            $(el).css( css );
		        }

		        // If scrolling inside both thresholds, set element to position:fixed and width to 60%
		        else if( windowTop > thresholdTop ) {

		        	css.position 				= 'fixed';
		        	css.top 					= topBuffer;
		        	css.bottom 					= 'auto';
		        	css[horizontalOffsetFrom] 	= fixedHorizontalOffset;

		            $(el).css( css );
		        }

		        // Else is default position as set in CSS, above thresholdTop, element snapped to top of container and width to 100%
		        else {

		        	css.position 				= 'absolute';
		        	css.top 					= '0';
		        	css.bottom 					= 'auto';
		        	css[horizontalOffsetFrom] 	= initialHorizontalOffset;

		            $(el).css( css );
		        }

	        }


	        // If minimum viewport width is not met
	        else {
		        $(el).css({ 'position':'static' });
	        }


	    });

    };


	//==========================================================================================================================
	// mmgrid section interactions
	//==========================================================================================================================

	function mouseMoveAnim() {
		// Adding/Removing classes
		$('.mousemovecontainer').on('mouseleave blur', '.mousemovetrigger', function() {
			var that=this;
			var mmgrid_anim_timeout = setTimeout(function(){
				$(that).closest('.mousemovecontainer').find('.mousemovetarget img').removeClass('active').css({'transform': 'scale(1) translate(0px,0px)'});

				if( $(that).closest('.mousemovecontainer').find('.arrow-link-container').length > 0 ) {
					$(that).closest('.mousemovecontainer').find('.arrow-link-container').removeClass('active');
				}

			}, 120, that);

			$(this).closest('.mousemovecontainer').data('mmgrid_anim_timeout', mmgrid_anim_timeout);

		});
		$('.mousemovecontainer').on('mouseenter focus', '.mousemovetrigger', function() {
			$(this).closest('.mousemovecontainer').find('.mousemovetarget img').addClass('active');
			
			if( $(this).closest('.mousemovecontainer').find('.arrow-link-container').length > 0 ) {
				$(this).closest('.mousemovecontainer').find('.arrow-link-container').addClass('active');
			}
		});


		// Mousemove animation
		var mouseX=0, mouseY=0, moveX=0, moveY=0, lastMove=0, eventThrottle=100;

		$('.mousemovecontainer').on('mousemove', '.mousemovetrigger', function(e) {
			e.preventDefault();

			clearTimeout($(this).closest('.mousemovecontainer').data('mmgrid_anim_timeout'));

			var img = $(this).closest('.mousemovecontainer').find('.mousemovetarget img');

			var offset = img.offset();
			var width = img.width();
			var height = img.height();

			var centerX = offset.left + width / 2;
			var centerY = offset.top + height / 2;

			var now = Date.now();

			mouseX = e.pageX;
			mouseY = e.pageY;

			moveX = (mouseX-centerX) / -30;
			moveY = (mouseY-centerY) / -30;

			// Throttle
			if (now > lastMove + eventThrottle) {
				lastMove = now;
				$(img).css({'transform': 'scale(1.1) translate('+moveX+'px,'+moveY+'px)'});
			}
		});
	}
	
	// TODO: Voir quand WC sera à jour pour AJAX
// 	$('.product-quantity input.qty').change(function() {
// 		$('.actions').find('[name=update_cart]').click();
// 	});




	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {


				$('[role="alertdialog"]').find('.alert-close').click(function() {
					$(this).parents('[role="alertdialog"]').attr('aria-expanded', false);
					
					$cookie 		= $(this).attr('data-cookie');
					$expiration = $(this).attr('data-expiration');
					$nonce = $(this).attr('data-nonce');
					
					var ajaxurl = document.location.origin + '/wp-admin/admin-ajax.php',
							data = {
								action: 'set_alert_cookie',
								cookie: $cookie,
								expiration: $expiration,
								security: $nonce,
							};
					$.post(ajaxurl, data, function(response) {
						//
					});					

					
				});

 				// ======================================
                // Setting full height on some sections
                // ======================================
                function fullHeight() {
	                var vph = viewport().height,
	                    headerHeight = $('#main_nav_elements').height();

	                if( viewport().width <= 767 ) {
	                	$('.full-height').height(vph);
	                }
	                else {
	                	$('.full-height').height(vph - headerHeight);
	                }

	                if( viewport().width <= 999 ) {
	                	$('.70-height-tablet').height(vph*0.7);
	                }

                }

                fullHeight();

                $(window).on('resize orientationchange', function() {
                	fullHeight();
                });



				//==========================================================================================================================
				// Vertical Menu color management via midnight.js
				// jQuery plugin used to change vertical menu color on the fly depending on the current section background-color
				//==========================================================================================================================
				$('.midnightHeader').css('transform', 'scale(1)');
				$('#menuwrapper').midnight();





				// ===========================================
                // Make header changes if scrolling past 1px
                // ===========================================                
				

				function push_header() {
					$('#main_nav_elements .nav_primary, #nav_secondary').addClass('pushed-away');
					$('.burger-box ').css('display', 'inline-block');
					$('.logo_g ').css('display', 'none');
				}
				function pull_header() {
					$('#main_nav_elements .nav_primary, #nav_secondary').removeClass('pushed-away');
					$('.burger-box ').css('display', 'none');
					$('.logo_g ').css('display', 'inline-block');
				}

				function manageTopHeader() {
					if( $(window).scrollTop() > 0 ) {
						push_header();
                	}
                	else {
						pull_header();
                	}
				}

				if( !$('body').hasClass('no_header_change') ) {                	
	                // Managing when manageTopHeader function fires;
	                manageTopHeader();
	                $(window).on('scroll', function(e) {
	                	manageTopHeader();
	                });
                }
                else {
                	push_header();
                }




				//==========================================================================================================================
				// Mega menu interaction
				//==========================================================================================================================


                // ======================================
                // Function to disable scrolling
                // ======================================
                function disableScroll() {
                    if ($(document).height() > $(window).height()) {
                        $('body').css('overflow', 'hidden');
                        $('#sitewrapper').css({'overflow': 'scroll'});
                    }                    
                }
                function enableScroll() {
                    $('body').css('overflow', 'auto');
                    $('#sitewrapper').css('overflow', 'hidden');
                }


				//****************************
				// The function that makes megamenu appear
				// Parameter divtoshow : div to show inside the megamenu
				// Parameter hoverflag : wheter to close menu if mouseout or not
				//****************************
				function showMegaMenu(divtoshow, activeLink) {
					var self = activeLink;

    				$('#menuwrapper').addClass('megamenu-opened');
					$('#megamenubg').css('display','block').stop().animate({'opacity':1},150);
					$('#main_nav_elements').addClass('active');
					$('#mega-menu').addClass('opened');

					/*if( self === undefined ) {
						// Default active link is products
						$('.nav_primary a').removeClass('active');
						$('.menu-bouton-produits a').addClass('active');
					}
					else {
						$('.nav_primary a').each(function() {
							if(this !== self) {
								$(this).removeClass('active');                  
							}
							else {
								$(this).addClass('active');                 
							}
						});                     
					}

					$('#mega-menu > div').each(function() {
						if( !$(this).is(divtoshow)) {
							$(this).removeClass('opened');
						}
					});*/

					$('#mega-menu').css('display','block').stop().animate({'opacity':1},200);
					// $(divtoshow).addClass('opened');
					$('#mega-menu_mobile').addClass('opened');

					clearTimeout($('#mega-menu').data('timeoutId'));
				}

				// Close the megamenu and apply all related operations
				function closeMegaMenu() {
					$('#menuwrapper').removeClass('megamenu-opened');
					$('#megamenubg').stop().animate({'opacity':0},150).promise().done(function() {
						$(this).css('display','none');
					});
					$('#main_nav_elements').removeClass('active');
					$('#nav_secondary').removeClass('active');
					$('#mega-menu').removeClass('opened');
					$('#mega-menu').stop().animate({'opacity':0},200).promise().done(function() {
						$(this).css('display','none');
					});

					$('#mega-menu_mobile').removeClass('opened');
					$('.nav_primary a.active').removeClass('active');

					if( $('#main_nav_elements_clone').length > 0 ) {
						$('#main_nav_elements_clone').stop().animate({'opacity':0},200).promise().done(function() {
							$(this).remove();
						});
					}
					if( $('#nav_secondary_clone').length > 0 ) {
						$('#nav_secondary_clone').stop().animate({'opacity':0},200).promise().done(function() {
							$(this).remove();
						});
					}
				}






				//==========================================================================================================================
				// Burger interaction
				//==========================================================================================================================

				function burgerReset() {
					$('.burger-box').removeClass('burger-opened');
					closeMegaMenu();

					/*$('body').off('mouseover.eleganzaNav', '.nav_primary a');

					var mouseoverOn = setTimeout(function() {
						$('body').on('mouseover.eleganzaNav', '.nav_primary a', function navhandler(event) {
							navMouseOver(event, this);
						});
					}, 220);*/
				}

				function burgerActivate() {
					$('.burger-box').addClass('burger-opened');

					showMegaMenu();

					var navClone = $('#main_nav_elements').clone();
					var secondNavClone = $('#nav_secondary').clone();

					if( $('#main_nav_elements_clone').length <= 0 ) {
						$(navClone).css('position', 'fixed')
									.attr('id','main_nav_elements_clone')
									.removeClass('blackshadowright')
									.insertBefore('#main_nav_elements')
									.stop().animate({'opacity':1},200);
					}
					if( $('#nav_secondary_clone').length <= 0 ) {
						$(secondNavClone).css('position', 'fixed')
									.attr('id','nav_secondary_clone')
									.insertBefore('#nav_secondary')
									.stop().animate({'opacity':1},200);
					}

					$(window).trigger('resize');
				}


				// Managing burger icon clicks
				$('.burger-box').on('click', function burgerBox(event) {

					//Preventing quick double-clicks bug
					$('.burger-box').off('click', burgerBox);
					var clickoff = setTimeout(function() {
						$('.burger-box').on('click', burgerBox);
					}, 200);

					if( $(this).hasClass('burger-opened') ) {
						burgerReset();
					}
					else {
						burgerActivate();
					}
				});


				// Close megamenu if click out of it
                /*$(document).on('click touchstart', function(event) {
                    if( $('#mega-menu').hasClass('opened') ) {
	                    if ( !$(event.target).closest('#mega-menu').length &&
	                    	 !$(event.target).closest('#main_nav_elements').length &&
	                    	 !$(event.target).closest('#main_nav_elements_clone').length && 
	                    	 !$(event.target).closest('#menuwrapper').length && 
	                    	 !$(event.target).closest('#megamenubg').length ) {

                            burgerReset();
                        }
                    }
                });*/





                //==========================================================================================================================
				// Footer form submit
				//==========================================================================================================================
                $('#newsletter-form-submit').on('click', function() {
					$('#newsletter_form').submit();
				});

				$( "#datepicker" ).datepicker({ 
					changeYear: true,
					dateFormat: "yy-mm-dd",
					yearRange: "-70:-10"
				});


			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired


				// =============================
                // Input styling
                // =============================
                /*var inputs = $('input[type=text], input[type=email], input[type=password], input[type=number], input[type=tel], select, textarea');

                function labelUpdate(el) {
                    var label = $("label[for='"+$(el).attr('id')+"']");

                    if( $(el).val() !== "" ) {
                        $(el).addClass('gotContent');
                        $(label).css('visibility', 'visible');
                    }
                    else {
                        $(el).removeClass('gotContent');
                        $(label).css('visibility', 'hidden');                       
                    }
                }


                inputs.on('input change', function() {
                    labelUpdate(this);
                });


                $(document).ready(function() {
                    inputs.each(function() {
                        labelUpdate(this);
                    });
                });*/


				

				$(window).on('resize', function() {

					if( viewport().width >= 768 ) {
						// Manage megamenu width
						var width = $('#main_nav_elements').width(),
							megamenuML = $('#mega-menu').css('margin-left'),
							secondNavWidth = $('#nav_secondary').width();

						megamenuML = parseFloat(megamenuML.replace('px', ''));

						$('#main_nav_elements_clone').width(width);
						$('#megamenubg').width(width);
						$('#mega-menu').width(width - megamenuML);
						$('#nav_secondary_clone').width(secondNavWidth);
					}
					else {
						document.getElementById('megamenubg').style.removeProperty('width');
						document.getElementById('mega-menu').style.removeProperty('width');
					}

				});


			}
		},
		// Fires sur les pages accueil et tendances
		'swiper_page': {
			init: function() {
				// JavaScript to be fired on the home page
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS

				var instagramSwiper;
				
				function checkForSwiper() {

					if( viewport().width <= 999 && !instagramSwiper && $('.instagram_img_container').length>0) {
						
						instagramSwiper = new Swiper ('.instagram_img_container', {
							// Optional parameters
							direction: 'horizontal',
							loop: true,
							slidesPerView: 4,
							spaceBetween: 10,

							breakpoints: {
								// when window width is <= 480px
								480: {
									slidesPerView: 1.3,
									loop: true
								},
								// when window width is <= 767px
								768: {
									slidesPerView: 2.3,
									loop: true
								},
								// when window width is <= 991px
								999: {
									slidesPerView: 3.3,
									loop: true
								}
							}
						});
					}

					
					else if ( viewport().width > 999 ) {
						
						if (instagramSwiper) {
							instagramSwiper.destroy();
							instagramSwiper = undefined;
						}

						$('.swiper-wrapper').attr('style','');
						$('.swiper-slide').css({'width': '', 'margin-right': ''});
						
					}

					// Adjust height of div.swiper-slides dynamically because there is no content inside, just a backgroundimage
					$('.instagram_img_container div.swiper-slide').each(function() {
						var width = $(this).width();
						$(this).height(width + 'px');
					});
				}

				checkForSwiper();
				$(window).resize( checkForSwiper );
			}
		},
		// Home page
		'home': {
			init: function() {



				var feat_products_swiper_1, feat_products_swiper_2, feat_products_swiper_3;
				
				function checkForSwiper() {

					if( viewport().width <= 999 && !feat_products_swiper_1 && $('#feat_products_swiper_1').length>0) {

						if( $('#feat_products_swiper_1').length > 0 ) {

							feat_products_swiper_1 = new Swiper ('#feat_products_swiper_1', {
								// Optional parameters
								direction: 'horizontal',
								loop: false,
								slidesPerView: 1.7,
								spaceBetween: 40,

								breakpoints: {
									// when window width is <= 480px
									480: {
										slidesPerView: 1.18,
										spaceBetween: 10
									},
									// when window width is <= 767px
									768: {
										slidesPerView: 1.7,
										spaceBetween: 20
									}
								}
							});

							//Update gallery before the start of each animation.
						    feat_products_swiper_1.on("setTransition", function() {
						      feat_products_swiper_1.update(true);
						    });
						}

						if( $('#feat_products_swiper_2').length > 0 ) {

							feat_products_swiper_2 = new Swiper ('#feat_products_swiper_2', {
								// Optional parameters
								direction: 'horizontal',
								loop: false,
								slidesPerView: 1.7,
								spaceBetween: 40,

								breakpoints: {
									// when window width is <= 480px
									480: {
										slidesPerView: 1.18,
										spaceBetween: 10
									},
									// when window width is <= 767px
									768: {
										slidesPerView: 1.7,
										spaceBetween: 20
									}
								}
							});

							//Update gallery before the start of each animation.
						    feat_products_swiper_2.on("setTransition", function() {
						      feat_products_swiper_2.update(true);
						    });
						}

						if( $('#feat_products_swiper_3').length > 0 ) {

							feat_products_swiper_3 = new Swiper ('#feat_products_swiper_3', {
								// Optional parameters
								direction: 'horizontal',
								loop: false,
								slidesPerView: 1.7,
								spaceBetween: 40,

								breakpoints: {
									// when window width is <= 480px
									480: {
										slidesPerView: 1.18,
										spaceBetween: 10
									},
									// when window width is <= 767px
									768: {
										slidesPerView: 1.7,
										spaceBetween: 20
									}
								}
							});

							//Update gallery before the start of each animation.
						    feat_products_swiper_3.on("setTransition", function() {
						      feat_products_swiper_3.update(true);
						    });
						}
					}

					
					else if ( viewport().width > 999 ) {
						
						if (feat_products_swiper_1) {
							feat_products_swiper_1.destroy();
							feat_products_swiper_1 = undefined;
						}
						if (feat_products_swiper_2) {
							feat_products_swiper_2.destroy();
							feat_products_swiper_2 = undefined;
						}
						if (feat_products_swiper_3) {
							feat_products_swiper_3.destroy();
							feat_products_swiper_3 = undefined;
						}

						$('.swiper-wrapper').attr('style','');
						$('.swiper-slide').css({'width': '', 'margin-right': ''});
						
					}
				}

				checkForSwiper();
				$(window).resize( checkForSwiper );


				



				// ======================================
                // ScrollMagic Instagram animation
                // ======================================
                if( $('#instagram_section .swiper-slide').length >= 4 ) {

	                var inst0 = $('#instagram_section .swiper-slide')[0],
	                	inst1 = $('#instagram_section .swiper-slide')[1],
	                	inst2 = $('#instagram_section .swiper-slide')[2],
	                	inst3 = $('#instagram_section .swiper-slide')[3],
	                	instAnimTL = new TimelineMax(),
	                	instController = new ScrollMagic.Controller(),
	                	instScene;


					instAnimTL
					    .fromTo(inst0, 0.6, {y:20, opacity:0, rotation:0}, {y:0, opacity:1, rotation:0.01})
					    .fromTo(inst1, 0.6, {y:20, opacity:0, rotation:0}, {y:0, opacity:1, rotation:0.01}, 0.2)
					    .fromTo(inst2, 0.6, {y:20, opacity:0, rotation:0}, {y:0, opacity:1, rotation:0.01}, 0.4)
					    .fromTo(inst3, 0.6, {y:20, opacity:0, rotation:0}, {y:0, opacity:1, rotation:0.01}, 0.6);


					// create a scene
					instScene = new ScrollMagic.Scene({
					    })
						.setTween(instAnimTL)
						.triggerElement('#instagram_section .swiper-container')
						.triggerHook('1')
					    .addTo(instController); // assign the scene to the controller
				}





				// =========================================================
                // ScrollMagic instances enable/disable management
                // depending on viewport size
                // =========================================================
				function controllersManager() {

					var viewportWidth = viewport().width;
					
					if(instController!==undefined) {						
						if (viewportWidth <= 999 && instController.enabled()) {
					    	instController.enabled(false);
						}
						else if (!instController.enabled()) {
					    	instController.enabled(true);
						}
				    	instController.update(true);
					}
				}
				
				controllersManager();

				var resizeTimer;

				$(window).on("resize", function(e) {
					clearTimeout(resizeTimer);
				    resizeTimer = setTimeout(function() {
						controllersManager();
				    }, 250);
				});







				//==========================================================
				// mmgrid section interactions
				//==========================================================
				mouseMoveAnim();


			}
		},
		'archive' : {
			init: function() {

                // =========================================================
                // Manage content toggles
                // =========================================================
                $('#atb_sidebar_mobile .content_item_title_wrapper').on('click', function() {
                	var togglePlus = $(this).find('.toggle_plus');
                	var toggleMinus = $(this).find('.toggle_minus');

                	$(this).toggleClass('content_opened');
                	
					
					if( $(this).hasClass('content_opened') ) {
						$(togglePlus).css('display', 'none');
						$(toggleMinus).css('display', 'block');
               		}
               		else {
               			$(togglePlus).css('display', 'block');
						$(toggleMinus).css('display', 'none');
               		}

               		var ul = $('#atb_sidebar_mobile ul');

                	if(ul.hasClass('opened')) {
                		ul.removeClass('opened');
                		ul.stop().slideUp();
                	}
                	else {
                		ul.addClass('opened');
                		ul.stop().slideDown();
                	}

                });





				// =========================================================
                // Filter system
                // =========================================================
                $('.filter-item').on('click', function() {
                	var target, filter, container, mobileUl;
									
                	container = $('#atb_content-with-sidebar');
                	mobileUl = $('#atb_sidebar_mobile ul');

                	// mobileUl.removeClass('opened');
                	// mobileUl.stop().slideUp();

                	// If click on currently active filter, set target to all sections and clear filter
                	if($(this).hasClass('active')) {
                		target = $('.filtered_item:not([data-filters=no-items])');
                		$(this).removeClass('active');
                	}
                	// Else, clear all filters, activate new filter and set target section
                	else {
	                	filter = $(this).attr('data-filter');
	                	target = $('.filtered_item[data-filters*=filter-'+filter+']');

	                	$('.filter-item').removeClass('active');
	                	$(this).addClass('active');
                	}

                	// If no target to show, show default no job item
                	if(target.length===0) {
                		target = $('.filtered_item[data-filter=no-items]');
                	}

                	// Start by hiding any visible section
                	TweenMax.to('.filtered_item', 0.5, {opacity:0, onComplete:function(){
                		// Save container's height to make its height animatable
					    var oldHeight = container.height();

					    // Show up target items with appropriate classes
                		$('.filtered_item').addClass('hidden').removeClass('three-columns-odd three-columns-not3rd');
                		target.each(function(index) {
                			index+=1;
                			$(this).toggleClass('three-columns-odd', (index%2 === 1));
                			$(this).toggleClass('three-columns-not3rd', (index%3 !== 0));
                		});
                		target.removeClass('hidden');
                		TweenMax.to(target, 0.5, {opacity:1});

						$(window).triggerHandler("resize"); // Used to recalculate sidebar pin duration


                		// Animate height of the container
					    var newHeight = container.height();
					    container.height(oldHeight);

					    TweenMax.to(container, 0.5, {height: newHeight, ease:Power3.easeOut, onComplete:function(){
					        container.height('auto');
					    }});

					    // Scroll back to top
					    var top = $('#atb_content-with-sidebar').position().top;
					    top-=30;
					    TweenMax.to(window, 0.7, {scrollTo:top, ease:Power2.easeOut});
                	}});
                });



                // =========================================================
                // Pin filters when scrolling
                // =========================================================
                var filterController = new ScrollMagic.Controller();
                var scene = new ScrollMagic.Scene({
            				triggerElement: "#atb_sidebar",
            				triggerHook: 0.1

                		})
						.setPin("#atb_sidebar", {pushFollowers: false})
						.duration(300)
						.addTo(filterController);

				var durationValueCache;
				function getDuration () {
					return durationValueCache;
				}
				function updateDuration (e) {
					durationValueCache = $('.filtered_items_wrapper').innerHeight();
					durationValueCache -= $('#atb_sidebar').innerHeight();

					if(durationValueCache < 1) {
						durationValueCache = 1;
					}
				}

				



				// =========================================================
                // ScrollMagic instances enable/disable management
                // depending on viewport size
                // =========================================================
				function controllersManager() {
					
					if (viewport().width <= 999 && filterController.enabled()) {
				    	filterController.enabled(false);
					}
					else if (!filterController.enabled()) {
				    	filterController.enabled(true);
					}

					filterController.update(true);
				}
				
				controllersManager();

				var resizeTimer;

				$(window).on("resize", function(e) {
					clearTimeout(resizeTimer);
				    resizeTimer = setTimeout(function() {
						controllersManager();
				    }, 250);

				    updateDuration();
				});

				$(window).triggerHandler("resize"); // set to initial value
				scene.duration(getDuration); // supply duration method

			}
		},
		'page_template_page_help' : {
			init: function() {

				// =========================================================
                // Open filter on mobile
                // =========================================================
                $('#atb_sidebar_mobile p').on('click', function() {
                	var ul = $('#atb_sidebar_mobile ul');

                	if(ul.hasClass('opened')) {
                		ul.removeClass('opened');
                		ul.stop().slideUp();
                	}
                	else {
                		ul.addClass('opened');
                		ul.stop().slideDown();
                	}
                });

				


                // =========================================================
                // Pin filters when scrolling
                // =========================================================
                var filterController = new ScrollMagic.Controller();
                var scene = new ScrollMagic.Scene({
            				triggerElement: "#atb_sidebar",
            				triggerHook: 0.1

                		})
						.setPin("#atb_sidebar", {pushFollowers: false})
						.duration(300)
						.addTo(filterController);

				var durationValueCache;
				function getDuration () {
					return durationValueCache;
				}
				function updateDuration (e) {
					durationValueCache = $('.atb_content-with-sidebar_wrapper').innerHeight();
					durationValueCache -= $('#atb_sidebar').innerHeight();

					if(durationValueCache < 1) {
						durationValueCache = 1;
					}
				}

				



				// =========================================================
                // ScrollMagic instances enable/disable management
                // depending on viewport size
                // =========================================================
				function controllersManager() {
					
					if (viewport().width <= 999 && filterController.enabled()) {
				    	filterController.enabled(false);
					}
					else if (!filterController.enabled()) {
				    	filterController.enabled(true);
					}

					filterController.update(true);
				}
				
				controllersManager();

				var resizeTimer;

				$(window).on("resize", function(e) {
					clearTimeout(resizeTimer);
				    resizeTimer = setTimeout(function() {
						controllersManager();
				    }, 250);

				    updateDuration();
				});

				$(window).triggerHandler("resize"); // set to initial value
				scene.duration(getDuration); // supply duration method





				// =========================================================
                // Manage content toggles
                // =========================================================
                $('.content_item_title_wrapper').on('click', function() {
                	var target = $(this).next('.content_item_content');
                	var togglePlus = $(this).find('.toggle_plus');
                	var toggleMinus = $(this).find('.toggle_minus');

                	$(this).toggleClass('content_opened');
                	$(target).slideToggle(400, function() {
                		// Update anchors height
				    	updateDuration();
                	});
					
					if( $(this).hasClass('content_opened') ) {
						$(togglePlus).css('display', 'none');
						$(toggleMinus).css('display', 'block');
               		}
               		else {
               			$(togglePlus).css('display', 'block');
						$(toggleMinus).css('display', 'none');
               		}

                });





                // =========================================================
                // Manage anchors active state on scroll
                // =========================================================
                function checkActiveAnchor() {
                	var sidebarTopPos = $('#atb_sidebar').offset().top;

                	$('.content_section').each(function() {
                		var sectionPos = $(this).offset().top;
						var sectionHeight = $(this).innerHeight();
						var sectionBottom = sectionPos+sectionHeight;
						var anchor = $(this).attr('id');

						if( sidebarTopPos >= sectionPos && sidebarTopPos < sectionBottom ) {
							$('#atb_sidebar .filter-item').removeClass('active');
							$('#atb_sidebar .filter-item[data-anchor='+anchor+']').addClass('active');
						}
                	});
                }

				var scrollTimer;
				$(window).on("scroll", function(e) {
					clearTimeout(scrollTimer);
				    scrollTimer = setTimeout(function() {
						checkActiveAnchor();
				    }, 10);
				});

				checkActiveAnchor();




				// =========================================================
				// Manage anchors scrollTo
				// =========================================================
				$('.scroll-item').on('click', function() {
					var anchor = $(this).attr('data-anchor'),
					targetTopPos = $("#"+anchor).offset().top,
					offset = $('#section_1').css('padding-bottom'),
					result = targetTopPos - offset.replace('px', '');
										
					var result = result + 'px';
					$('html, body').animate({scrollTop: result}, 300);
					
				});

			}
		},
		// 404 page
		'error404': {
			init: function() {
				mouseMoveAnim();
			}
		},

		'woocommerce_cart' : {
			init: function() {


				//=======================================
				// Customize quantity input in cart page
				//=======================================
				function customize_quantity_selector() {
					$('.quantity').each(function() {
						var value = $(this).children(".qty").val();
						$(this).siblings('.fake-quantity').find('span').text(value);
					});

					$('.qty').attr({'min': '1'});

					$(".minus, .plus").click(function(){

						var input = $(this).closest('.product-quantity').find('input.qty');
						var max = input.attr('max');
						var value = parseInt(input.val(), 10);
						var operator = $(this).hasClass("minus") ? -1 : +1;

						if(max==="") {max=50;}

						// Min and max
						if( operator===-1) {
							value = value + operator < 1 ? 2 : value;
						}
						else {
							value = value + operator > max ? max-1 : value;
						}

						input.val(value + operator).change();
						$(this).siblings('span').text(value + operator);

					});
				}
				customize_quantity_selector();






				//=============================================
                // Manage fixed position of #nuutok_map_image
                //=============================================
						
				if( $('#atb_floating_summary').length > 0 && $('#atb_cart_items_form').length > 0 ) {

	                var eventTimer;

					$(window).on('scroll load resize', function(e) {
						clearTimeout(eventTimer);
					    eventTimer = setTimeout(function() {

	                        $('#atb_floating_summary').mamboFixThis({
	                        	thresholdElement: $('#atb_cart_items_form'),
								requiredVPW: 1200,
								topBuffer: 150,
								horizontalOffsetFrom: 'right',
								initialHorizontalOffset: '0px',
								fixedHorizontalOffset: '50px'
	                        });


					    }, 5);

					});

		        }


			}
		},

		'single_product': {
			init: function() {

				//=======================================
				// Customize quantity input in cart page
				//=======================================
				function customize_quantity_selector() {
					$('.quantity').each(function() {
						var value = $(this).children(".qty").val();
					});

					$('.qty').attr({'min': '1'});

					$(".minus, .plus").click(function(){

						var input = $(".qty");
						var max = input.attr('max');
						var value = parseInt(input.val(), 10);
						var operator = $(this).hasClass("minus") ? -1 : +1;

						if(max==="") {max=10;}

						// Min and max
						if( operator===-1) {
							value = value + operator < 1 ? 2 : value;
						}
						else {
							value = value + operator > max ? max-1 : value;
						}

						input.val(value + operator).change();
						$(this).siblings('span').text(value + operator);

					});
				}
				customize_quantity_selector();

				$('.atb_custom_add_to_cart_button').on('click', function() {
					$('form.cart button[type="submit"]').trigger('click');
				});




				//=========================================================================================================
				// Customize variations selection
				//=========================================================================================================
				if( $('table.variations').length > 0 ) {

					// Create custom variations container if necessary
 					$('.woocommerce-variation-add-to-cart')
 						.before('<div id="atb_custom_variation_selection"></div>')
 						.find('.atb_custom_add_to_cart_button')
 						.addClass('disabled');

					//Custom variation selection creation
					$('table.variations tr').each(function() {	
						var variation_label = $(this).find('td.label label').html();
						var variation_slug = $(this).find('select').attr('id');

						$('#atb_custom_variation_selection').prepend('<div class="atb_var_row atb_var_row_'+variation_slug+'"><p class="tt">'+variation_label+' : <span class="atb_var_value_'+variation_slug+'"></span></p></div>');

						$(this).find('option').each(function() {
							var value = $(this).val();

							if(value !== '') {
								$('.atb_var_row_'+variation_slug).append('<div class="atb_var_option" data-label="'+variation_slug+'" data-option="'+value+'">'+value+'</div>');
							}
						});

					});

					// Listen to custom variation buttons
					$('body').on('click', '.atb_var_option', function(){

						var select_id = $(this).attr('data-label'),
								value = $(this).attr('data-option');
						
						$(this).parent().children().removeClass('active');		
						$(this).addClass('active');
						
						$('.woocommerce-variation-add-to-cart .atb_custom_add_to_cart_button').removeClass('disabled');
						
						$('select#'+select_id).val(value);
						$('select#'+select_id).trigger('change');

					});

					// Updates price in button and attribute values
					$('body').on('change', 'table.variations select', function() {
						
						var variation_price = $('.woocommerce-variation-price .woocommerce-Price-amount').html(),
								select_id 		= $(this).attr('id'),
								select_value 	= $(this).val();
						
						if ( select_value !== '' ) {

							var value_text 		= $('option[value='+select_value+']').text();	
							$('.atb_custom_add_to_cart_button p.price').html(variation_price);
							$('span.atb_var_value_'+select_id).html(value_text);
							
						}

					});



					// Trigger changes on pageload
					$('table.variations select').trigger('change');
				}




				//=========================================================================================================
				// Check for color parameter in URL and trigger related variation selection
				//=========================================================================================================
				function findGetParameter(parameterName) {
				    var result = null,
				        tmp = [];
				    location.search
				    .substr(1)
				        .split("&")
				        .forEach(function (item) {
				        tmp = item.split("=");
				        if (tmp[0] === parameterName) { result = decodeURIComponent(tmp[1]); }
				    });
				    return result;
				}

				var preSelectedColor = findGetParameter('preselectcolor');

				if ( preSelectedColor !== null ) {
					$('.atb_var_option[data-option='+preSelectedColor+']').trigger('click');
				}



				//==========================================================
				// mmgrid section interactions
				//==========================================================
				mouseMoveAnim();







				//==========================================================
				// swiper
				//==========================================================
				var related_products_swiper;
				
				function checkForSwiper() {

					if( viewport().width <= 999 && !related_products_swiper && $('#related_products_swiper').length>0) {

						if( $('#related_products_swiper').length > 0 ) {

							related_products_swiper = new Swiper ('#related_products_swiper', {
								// Optional parameters
								direction: 'horizontal',
								loop: false,
								slidesPerView: 1.7,
								spaceBetween: 40,

								breakpoints: {
									// when window width is <= 480px
									480: {
										slidesPerView: 1.18,
										spaceBetween: 10
									},
									// when window width is <= 767px
									768: {
										slidesPerView: 1.7,
										spaceBetween: 20
									}
								}
							});
						}

						
					}

					
					else if ( viewport().width > 999 ) {
						
						if (related_products_swiper) {
							related_products_swiper.destroy();
							related_products_swiper = undefined;
						}

						$('.swiper-wrapper').attr('style','');
						$('.swiper-slide').css({'width': '', 'margin-right': ''});
						
					}
				}

				checkForSwiper();
				$(window).resize( checkForSwiper );


			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.